import {
  Box,
  Flex,
  Grid,
  Heading,
  Image,
  ListItem,
  Text,
  VStack,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import React from "react";
import Education from "../pages/Education";
import { FaUniversity } from "react-icons/fa";

function EducationExp({ colorMode }) {
  return (
    <>
      <br />
      <br />
      <br />
      <Grid
        w="85%"
        gap="5"
        m="auto"
        gridTemplateColumns={{ base: "1fr", md: "repeat(2,1fr)" }}
        position="relative"
      >
        <Box position={"absolute"} w="100%">
          <Image
            src="https://d1edzrgaei4psf.cloudfront.net/newHome/12.svg"
            opacity=".3"
            w="100%"
          />
        </Box>
        <Flex flexDirection="column">
          <Flex w="full" justifyContent={"center"}>
            <Text
              color="orange.500"
              fontSize="22px"
              letterSpacing="20px"
              fontWeight="700"
            >
              CERTIFICATES
            </Text>
          </Flex>
          <br />
          <Flex
            flexDirection="column"
            gap="3"
            pl={{ base: "2", md: "10" }}
            mt="5"
            lineHeight={"2"}
          >
            <Heading letterSpacing={"1px"} size="md">
              KUSHAL YUVA PROGRAM
            </Heading>
            <motion.div
              initial={{
                x: -200,
                opacity: 0,
              }}
              transition={{
                duration: 0.8,
              }}
              whileInView={{
                opacity: 1,
                x: 0,
              }}
            >
              <Text letterSpacing={"1px"} as="i" fontWeight={"400"}>
                @ Kushal Yuva Skill Development Center Lakhisarai
              </Text>
            </motion.div>
            <Heading letterSpacing={"1px"} as="i" size="sm">
              {" "}
              Duration
            </Heading>
            <motion.div
              initial={{
                x: -200,
                opacity: 0,
              }}
              transition={{
                duration: 0.8,
              }}
              whileInView={{
                opacity: 1,
                x: 0,
              }}
            >
              <Text letterSpacing={"1px"}>10/2017 - 12/2017</Text>
            </motion.div>
            <Heading letterSpacing={"1px"} as="i" size="sm">
              COURSES
            </Heading>
            <motion.div
              initial={{
                x: -200,
                opacity: 0,
              }}
              transition={{
                duration: 0.8,
              }}
              whileInView={{
                opacity: 1,
                x: 0,
              }}
            >
              <li style={{ letterSpacing: "1px" }} letterSpacing={"1px"}>
                Bihar State Certificate in IT
              </li>
              <li style={{ letterSpacing: "1px" }}>
                Bihar State Certificate in CS
              </li>
              <li style={{ letterSpacing: "1px" }}>
                Bihar State Certificate in SS
              </li>
            </motion.div>
          </Flex>
        </Flex>
        <Flex flexDirection="column" gap="10">
          <Flex w="full" justifyContent={"center"}>
            <Text
              color="orange.500"
              fontSize="20px"
              letterSpacing="22px"
              fontWeight="700"
            >
              EDUACTION
            </Text>
          </Flex>
          <Education />
        </Flex>
      </Grid>
    </>
  );
}

export default EducationExp;
